import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import InfoTooltip from "../common/InfoTooltip";
import { useAuth } from "../router/authContext";
import { CA_HD_2027_REPORT_PATH } from "../../config/publishedReports";

const TECH_DOCS_PATH = `${CA_HD_2027_REPORT_PATH}/technical-details`;

export default function PublishedForecastLayout() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const onDocs = pathname === TECH_DOCS_PATH || pathname.startsWith(`${TECH_DOCS_PATH}/`);
  const hubPath = isAuthenticated ? "/home" : "/";

  return (
    <div className="flex h-screen flex-col bg-gray-50">
      <header className="flex h-14 flex-shrink-0 items-center justify-between gap-4 border-b border-slate-200 bg-white px-5">
        <div className="flex min-w-0 items-center gap-3">
          <Link to={hubPath} className="flex flex-shrink-0 items-center">
            <img src="/img/logo.png" alt="AmpTrans" className="h-8 w-auto" />
          </Link>
          <div className="flex min-w-0 items-center gap-1.5">
            <Link
              to={CA_HD_2027_REPORT_PATH}
              className="truncate text-sm font-semibold text-slate-900 no-underline hover:underline underline-offset-2 sm:text-base"
            >
              CA Heavy Duty Load Forecast
            </Link>
            <InfoTooltip label="About this load forecast">
              The totals and map hexagons show the{" "}
              <span className="font-medium text-gray-800">
                expected charging load from heavy-duty trucks
              </span>{" "}
              for the selected year, according to the California Energy Commission (CEC)
              vehicle stock projection.
            </InfoTooltip>
          </div>
        </div>
        <div className="flex flex-shrink-0 items-center gap-4">
          {onDocs ? (
            <Link
              to={CA_HD_2027_REPORT_PATH}
              className="text-sm font-medium text-slate-600 no-underline hover:text-slate-900 hover:underline underline-offset-2"
            >
              Back to forecast
            </Link>
          ) : (
            <Link
              to={TECH_DOCS_PATH}
              className="text-sm font-medium text-slate-600 no-underline hover:text-slate-900 hover:underline underline-offset-2"
            >
              Technical documentation
            </Link>
          )}
          <Link
            to={isAuthenticated ? "/home" : "/login?mode=register"}
            className="rounded-md bg-blue-700 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-800"
          >
            {isAuthenticated ? "Solution Hub" : "Sign up"}
          </Link>
        </div>
      </header>
      <main className="min-h-0 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
